import RichText from "@/components/RichText";
import CtaButtonBlocks, { ctaButtonBlocks } from "./CtaButtonBlocks";

// Valeurs par défaut identiques à theme_service.DEFAULT_PROPS["rich_text"]
// — voir HeroSection.jsx pour l'explication du repli.
const DEFAULTS = {
  heading: "",
  body: "",
  text_align: "left",
};

const ALIGN_CLASS = {
  left: "text-left items-start",
  center: "text-center items-center mx-auto",
  right: "text-right items-end ml-auto",
};

export default function RichTextSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const alignClass = ALIGN_CLASS[t.text_align] || ALIGN_CLASS.left;
  const extraButtons = ctaButtonBlocks(blocks);

  return (
    <section className="max-w-[760px] mx-auto px-6 py-section md:py-section-md">
      <div className={`flex flex-col ${alignClass}`}>
        {t.heading && (
          <RichText
            as="h2"
            className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink"
            html={t.heading}
          />
        )}
        {t.body && (
          <RichText
            as="div"
            preserveParagraphs
            className="text-[16px] text-graphite mt-4 leading-relaxed max-w-[65ch] [&_a]:underline [&_a]:text-gold"
            html={t.body}
          />
        )}
        {/* Boutons ajoutés depuis le Studio (blocs "cta_button") — cette
            section n'en affichait aucun jusqu'ici. Le conteneur suit
            l'alignement du texte, imposé par `alignClass` sur le parent. */}
        {extraButtons.length > 0 && (
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <CtaButtonBlocks blocks={blocks} tone="light" />
          </div>
        )}
      </div>
    </section>
  );
}
